import axios from 'axios'
import { headersTokenConfig } from '../config/HeaderToken'

class MasterBonus {
  list() {
    const url = process.env.REACT_APP_API_URL_V2 + '/bonus?page=1&limit=100'
    return axios.get(url, headersTokenConfig)
  }

  add(payload) {
    const endPoint = `/bonus`
    const url = process.env.REACT_APP_API_URL_V2 + endPoint

    return axios.post(url, payload, headersTokenConfig)
  }

  update(id, payload) {
    const endPoint = `/bonus/${id}`
    const url = process.env.REACT_APP_API_URL_V2 + endPoint

    return axios.put(url, payload, headersTokenConfig)
  }

  updateStatus(id, payload) {
    const endPoint = `/bonus/${id}/status`
    const url = process.env.REACT_APP_API_URL_V2 + endPoint

    return axios.put(url, payload, headersTokenConfig)
  }

  delete(id, payload) {
    const endPoint = `/bonus/${id}`
    const url = process.env.REACT_APP_API_URL_V2 + endPoint
    
    return axios.delete(url, {...headersTokenConfig, data: payload})
  }
}

export default new MasterBonus()
